$(document).ready(function() {
    // function t() {
       
    //     $.ajax({
    //         url: "/cart?view=slidecart",
    //         dataType: "HTML",
    //         method: "GET",
    //         success: function(t) {
    //             t = $(t).find(".js-cart-update").html(), 
    //             $(".js-cart-update").html(t), t = $("html, body"), jQuery.getJSON("/cart.js", function(t) {
    //                 $(".cart-link__bubble").text(t.item_count);
    //                 if(t.item_count == 0){
    //                     $('.drawr_cart_note').val('');
                       
    //                     //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "");
                      
    //                 }
                    
    //             }), t.stop().animate({
    //                 scrollTop: 0
    //             }, 200, function() {
                  
    //                 $(".cart-link").trigger("click")
    //             })
    //         }
    //     })
    // }

    // function e(e, n) {
    //     //
    //     $.ajax({
    //         url: "/cart/add.js",
    //         method: "POST",
    //         dataType: "JSON",
    //         data: {
    //             quantity: n,
    //             id: e
    //         },
    //         success: function(e) {
    //             t()
    //         }
    //     })
    // }

    // function n(e, n) {
    //     var c = {};
    //     c[e] = n;
        
    //      $.ajax({
    //         url: "/cart/update.js",
    //         method: "POST",
    //         dataType: "JSON",
    //         data: {
    //             updates: c
    //         },
    //         success: function(e) {
                
    //             console.log(e), t()
    //             var cartNote = $('.drawr_cart_note').val();
    //             var finalNote = 'note=' + cartNote;
                
                
    //             jQuery.post(window.Shopify.routes.root + 'cart/update.js', finalNote);
    //             // $('.drawr_cart_note').val(cartNote);
    //         },
    //         error: function(error) {
    //             console.log(error)
    //         }
    //     })
    // }


  // $(document).on("change", ".product-single__form-atc .product-variant input[type='radio']", function(e) {
  //     e.preventDefault();
  //     console.log('change')
  //     var selected_variant_ID = $(this).attr('curr_var_id');
  //     var selected_variant_PRICE = $(this).attr('curr_var_price');
  //     var selected_variant_COMPARE_PRICE = $(this).attr('curr_var_compare_price');
  //     var selected_variant_DISCOUNT = $(this).attr('curr_var_discount');
  //     var selected_variant_AVAILABLE = $(this).attr('curr_var_available');
  //     var selected_variant_IMAGE = $(this).attr('curr_var_img');
    
  //   $(this).parents('.product-wrapper').find('.product-variant-id').val(selected_variant_ID);
  //   if(selected_variant_IMAGE){
  //     $(this).parents('.product-wrapper').find('.product-top-img-wrapper').attr('src',selected_variant_IMAGE);
  //   }
    
  //   if(selected_variant_COMPARE_PRICE > selected_variant_PRICE){
  //     $(this).parents('.product-wrapper').find('.product-price .sale-price span.block_product_price').text(selected_variant_PRICE);
  //     $(this).parents('.product-wrapper').find('.product-price .sale-price del').text(selected_variant_COMPARE_PRICE);
  //     $(this).parents('.product-wrapper').find('.product-price .sale-price .discount-percentage .discount-amount').text(selected_variant_DISCOUNT);
  //   }else{
  //     $(this).parents('.product-wrapper').find('.product-price .sale-price').text(selected_variant_PRICE);
  //   }
    
  //   if(selected_variant_AVAILABLE){
  //     $(this).parents('.product-wrapper').find('.quick-atc-btn .quick-add__submit span').text('Order');
  //   }else{
  //     $(this).parents('.product-wrapper').find('.quick-atc-btn .quick-add__submit span').text('Sold Out');
  //   }
    
  //   }); 



  

// ME comment
  
    // $(document).on("change", ".product-single__form-atc .product-variant input[type='radio']", function(t) {
    //     var e = $(t.target).parents("form.product-single__form-atc").eq(0),
    //         n = e.find("input[type='radio']:checked").val();
    //     e.find("select[name='id']").find("option").each(function(t, c) {
    //         $(c).removeAttr("selected", ""), -1 !== $(c).text().indexOf(n) && (console.log($(c)), $(c).attr("selected", "selected"), e.find("select[name='id']").trigger("change"))
    //     })
    //    var selected_variant_ID = $(this).attr('curr_var');
    //   $(this).parents('.product-wrapper').find('.product-variant-id').val(selected_variant_ID);
    // }),$(document).on("change", ".product-single__form-atc .product_color select", function(t) {
    //     var e = "";
    //     $(".product_color").each(function() {
    //         $(this).find("select[class='option_select']").each(function() {
    //             $(this).attr("id"), "" != e && (e += " / "), e += $("#${each_id}").find(":selected").val()
    //         }), $("#VariantSelect option").removeAttr("selected"), $('#VariantSelect option[value="${variant}"]').prop("selected", !0)
    //     }), $("#VariantSelect").trigger("change")
    // }),$(document).on("click", ".product-single__form-atc .add-to-cart", function(t) {
    //     t.preventDefault(), t = t.target, t = $(t).parents("form.product-single__form-atc").eq(0), e($(t).find('[name="id"]').val(), 1)
    // }), $(document).on("click", ".cart-product-quantity .qty-input .more-js", function(t) {
    //     t.preventDefault(), n($(this).parent().find("input").attr("data-id"), parseInt($(this).parent().find("input").val()) + 1)
    // }), $(document).on("click", ".cart-product-quantity .qty-input .less-js", function(t) {
    //    +

    //     t.preventDefault(), n($(this).parent().find("input").attr("data-id"), parseInt($(this).parent().find("input").val()) - 1)
        
        
    // }), $(document).on("click", ".cart-product-price-right a", function(t) {
    //     t.preventDefault(), n($(this).parents(".cart-product-item-text").find(".cart-product-quantity input").attr("data-id"), 0)
    // }), $(document).on("click", ".slider-add-to-cart", function(t) {
    //     t.preventDefault(), e($(this).attr("data-id"), 1)
    // }), $(document).on("click", ".button--tertiary", function(t) {
    //     location.reload()
    // })
  
});



// $('.variant-input [type="radio"]').on('change', function(e) {
//     e.preventDefault();
//     var currentElement = $(this).val();
//     var didFind = 'unavailable';
//     var optionsArray = new Array();
//     $(".variant-input input[type=radio]:checked").each(function(ix,em) {
//         console.log('-----------');
//         console.log(ix);
//         console.log(em);
//         console.log('-----------');
//         let currentIndex = $(em).attr('data-option-index');
//         let valueOfEM = $(em).val();
//         let reducedIx = parseInt(currentIndex) - 1;
//         console.log('reducedIx ' + reducedIx);
//         $(`span[data-option-index="${reducedIx}"]`).text(valueOfEM);
//         optionsArray.push($(this).val());
        
//     });
     
//     var variantsOption = optionsArray.join(" / ");
//     $("#product_var option").each(function() {
//         if ($(this).text() == variantsOption) {
//             var update_var_id = $(this).attr('data-variant_id');
//             $('.js-cw-product-page-form input[name="id"]').val(update_var_id);
//             $(this).prop("selected", true).trigger('change');
//             if ($(this).attr('data-available') == "true") {
//                 didFind = true;
//                 let cpPrice = $(this).attr("data-compareat-price");
//                 let price = $(this).attr("data-price");
//             } else {
//                 didFind = false;
//                 return false;
//             }
//         }

//     });
//     console.log(`didFind ${didFind}`);
//     if (didFind == false) {
//         $(".product-form__submit").addClass("pro-js-disabled");
//         $(".product-form__submit").addClass("disabled");
//         $(".product-form__submit").addClass("btntransparent");
//         $(".product-form__submit").text("Sold out"); 
        
//     } else if (didFind == 'unavailable') {
//         $(".product-form__submit").addClass("pro-js-disabled");
//         $(".product-form__submit").addClass("disabled");
//         $(".product-form__submit").addClass("btntransparent");
//         $(".product-form__submit").text("Unavailable"); 
//     } else {
//         window.setTimeout(function () {
//         $(".product-form__submit").removeClass("pro-js-disabled");
//         $(".product-form__submit").removeClass("disabled");
//         $(".product-form__submit").prop("disabled", false);
//         $(".product-form__submit").text("Add to cart");
//         }, 500);
//     }
  
//     var imagePath1 = $("#product_var option:selected").attr("data-image");   
//     var variantName = $("#product_var option:selected").text();
//     $(".variant-label-option-value").text(variantName);

//     $('.pdp-slider-nav li').each(function() {
        
//         var image_index = $(this).attr('data-slick-index');

//         let slick_image = $(this).find('img').attr('src');
    
//         slick_image = slick_image.split('&width=');
//         if (imagePath1 == slick_image[0]) {           
            
//             $('.pdp-slider-for').slick('slickGoTo', parseInt(image_index));
        
//         }
//     });
  


// });


// ME Comment
// $(document).on(`click`,`.js-cw-product-page-form .product_page_atc`,function(e){
//     e.preventDefault();
  
//         e.preventDefault();
//         let items = Array();
//         let form_data_array = $(`.js-cw-product-page-form`).serializeArray();
//         let item = {};
//         form_data_array.forEach((em,ix) => {
//             item[em.name] = em.value;
//         });
//         items.push(item);
     
//         $.ajax({
//             url : "/cart/add.js",
//             data : form_data_array,
//             method : "POST",
//             dataType : "JSON",
//             success  : function() {
//                 $.ajax({
//                     url: "/cart?view=slidecart",
//                     dataType: "HTML",
//                     method: "GET",
//                     success: function (t) {
//                         (t = $(t).find(".js-cart-update").html()),
//                             $(".js-cart-update").html(t),
//                             (t = $("html, body")),
//                             jQuery.getJSON("/cart.js", function (t) {
//                                 $(".cart-link__bubble").text(t.item_count);
//                             }),
//                             t.stop().animate({ scrollTop: 0 }, 200, function () {
//                                 $(".cart-link").trigger("click");
//                             });
//                     },
//                 });
                 
//             },
//             error:function(data){
//                 window.alert(data.responseJSON.description);
//             }
//         });

      
//     });

   
    
  // $(document).on("change", ".js-main-select select", function(t) {
  //       t.preventDefault();
  //       let parent = $(t.target).parents(`.add_items_block`);
  //       // let test = parent.find('#js-product-dropdown');
        
  //       // var currentElement = $(this).val();
  //       let didFindTheVariant = false;
  //       var didFind = false;
  //       var optionsArray = new Array();
    
  //       parent.find($(".js-main-select select")).each(function () { 
  //         var currentSelectElement = $(this);
  //         var selectedValue = currentSelectElement.find("option:selected").val();
  //         optionsArray.push($(this).val()); 
  //       });
    
  //       var variantsOption = optionsArray.join(" / ");
  //       $(this).prop("selected", false);
        
  //       parent.find("#js-product-dropdown option").each(function () {
  //         var currentOption = $(this);
  //         if (variantsOption == currentOption.text()) {
  //           $(this).prop("selected", true);
  //           if (currentOption.attr('data-available') == "true") {
  //              didFind = true;
  //              didFindTheVariant = true;
              
  //             var test1 = parent.find("#js-product-dropdown option:selected").attr("data-price");
  //             parent.find('.js_rec_price').html(test1);
              
  //           } else {
  //             // alert("Sorry, that option is not available currently!");
  //             return false;
  //           }
  //         }
  //       });
    
  //       if (didFind == false) {
  //           parent.find(".rec_btn_atc").html("Sold Out");
  //           parent.find(".rec_btn_atc").css("opacity", "0.5");
  //           parent.find(".rec_btn_atc").css("pointer-events", "none");
  //       } else {
  //           parent.find(".rec_btn_atc").html('Add <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.70988 1.00977V13.7498" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /><path d="M1.33984 7.37883H14.0798" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /></svg>');
  //           parent.find(".rarec_btn_atc").removeClass("disabled");;
  //           parent.find(".rec_btn_atc").css("opacity", "1");
  //           parent.find(".rec_btn_atc").css("pointer-events", "all");
  //       }
  //       if( didFindTheVariant == false ) {
  //           $(".product-page-atc").html("Not Available");
  //           parent.find(".rec_btn_atc").html("Not Available");
  //           parent.find(".rec_btn_atc").css("opacity", "0.5");
  //           parent.find(".rec_btn_atc").css("pointer-events", "none");
  //         }else{
  //           parent.find(".rec_btn_atc").html('Add <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.70988 1.00977V13.7498" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /><path d="M1.33984 7.37883H14.0798" stroke="white" stroke-width="1.82" stroke-linecap="square" stroke-linejoin="round" /></svg>');
  //           parent.find(".rarec_btn_atc").removeClass("disabled");;
  //           parent.find(".rec_btn_atc").css("opacity", "1");
  //           parent.find(".rec_btn_atc").css("pointer-events", "all");
  //         }
  //     });

  // $(document).on("click", ".rec_btn_atc", function(e) {
  //       e.preventDefault();
  //       var currentElement = $(this);
  //       var variant_id = currentElement.parents('.add_items_block').find(".actual-variants option:selected").val();
         
  //       var quantity = 1;
  //       $(this).text('Added ');
  //       var itemsArray = [];
  //       var customItem = {
  //         id: variant_id,
  //         quantity: quantity
  //       };
  //       itemsArray.push(customItem);
        
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         dataType: 'json',
  //         data: {
		// 	id: variant_id,
		// 	quantity: quantity
		// },
  //         success: function (data) {
  //           window.setTimeout(function () {
  //               currentElement.parents('.add_items_block').find('.rec_btn_atc').text('Add');
  //           }, 1000);
            
  //           $.ajax({
  //               url: "/cart?view=slidecart",
  //               dataType: "HTML",
  //               method: "GET",
  //               success: function (t) {
  //                   (t = $(t).find(".js-cart-update").html()),
  //                       $(".js-cart-update").html(t),
  //                       (t = $("html, body")),
  //                       jQuery.getJSON("/cart.js", function (t) {
  //                           $(".cart-link__bubble").text(t.item_count);
  //                       }),
  //                       t.stop().animate({ scrollTop: 0 }, 200, function () {
  //                           $(".cart-link").trigger("click");
  //                       });
  //               },
  //           });
  //           var cartNote = $('.drawr_cart_note').val();
  //           var finalNote = 'note=' + cartNote;
           
  //           jQuery.post(window.Shopify.routes.root + 'cart/update.js', finalNote);
  //         },
  //         error: function (data) {
  //           alert(data.responseJSON.description);
  //         }
  //       });
  //     });

  // $(document).on("click", ".banner-video__order-btn", function(e) {
  //       e.preventDefault();
  //       var currentElement = $(this);
  //       var variant_id = currentElement.parents('.banner-video__product-item').find(".actual-variants option:selected").val();
        
  //       var quantity = 1;
  //       var itemsArray = [];
  //       var customItem = {
  //         id: variant_id,
  //         quantity: quantity
  //       };
  //       itemsArray.push(customItem);
        
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         dataType: 'json',
  //         data: {
  //   			id: variant_id,
  //   			quantity: quantity
  //   		},
  //         success: function (data) {
            
  //           $.ajax({
  //               url: "/cart?view=slidecart",
  //               dataType: "HTML",
  //               method: "GET",
  //               success: function (t) {
  //                   (t = $(t).find(".js-cart-update").html()),
  //                       $(".js-cart-update").html(t),
  //                       (t = $("html, body")),
  //                       jQuery.getJSON("/cart.js", function (t) {
  //                           $(".cart-link__bubble").text(t.item_count);
  //                       }),
  //                       t.stop().animate({ scrollTop: 0 }, 200, function () {
  //                           $(".cart-link").trigger("click");
  //                       });
  //               },
  //           });
  //           var cartNote = $('.drawr_cart_note').val();
  //           var finalNote = 'note=' + cartNote;
           
  //           jQuery.post(window.Shopify.routes.root + 'cart/update.js', finalNote);
  //         },
  //         error: function (data) {
  //           alert(data.responseJSON.description);
  //         }
  //       });
  //     });

      
    //   $(document).on("DOMSubtreeModified",'.cbb-frequently-bought-add-button',function(){ 
    //     console.log('cbb-frequently-bought-add-button clickk');
    //     if($(`.cbb-frequently-bought-add-button`).text().trim().toLowerCase() == 'ADDED') {
    //        console.log('cbb-frequently-bought-add-button');
    //         $.ajax({
    //             url: "/cart?view=slidecart",
    //             dataType: "HTML",
    //             method: "GET",
    //             success: function (t) {
    //                 (t = $(t).find(".js-cart-update").html()),
    //                     $(".js-cart-update").html(t),
    //                     (t = $("html, body")),
    //                     jQuery.getJSON("/cart.js", function (t) {
    //                         $(".cart-link__bubble").text(t.item_count);
    //                     }),
    //                     t.stop().animate({ scrollTop: 0 }, 200, function () {
    //                          $(".cart-link").trigger("click");
    //                     });
    //             },
    //         });
    //     }
    // });


    // $(document).on("mouseleave", ".drawr_cart_note", function(e) {
    //     alert(123);
    //     var cartNote = $('.drawr_cart_note').val();
    //     var finalNote = 'note=' + cartNote;
    //     jQuery.post(window.Shopify.routes.root + 'cart/update.js', finalNote);
    //   });

    // ME Comment
    // $(".drawr_cart_note").on("input", function() {
    //     let noteValue = $(this).val();
    //     $.ajax({
    //         type: "POST",
    //         url: "/cart/update.js",
    //         data: { note: noteValue },
    //         dataType: "json",
    //         success: function(response) {
    //             console.log("Cart note updated:", response);
    //         },
    //         error: function(xhr, status, error) {
    //             console.error("Error updating cart note:", error);
    //         }
    //     });
    // });



    //   Fixing code for radio input change
$(document).ready(function() {
    // $(document).on("click", '.product-variant input', function(e) {
    //     setTimeout(function () {
    //         var slected_value = $('.product__info-container .actual-variants option:selected').attr('data-variant_id');
    //         console.log('var id-' + slected_value);
    //         $('.js-cw-product-page-form.form input[name="id"]').val(slected_value).trigger('change');
    //     }, 100);
    // });

    // $('.product-variant input').click(function() {
    //     setTimeout(function () {       
    //      var current_var_id  = $('.product__info-container .actual-variants option:selected').attr('data-variant_id');
    //         console.log(current_var_id);
    //         if(current_var_id != '' && current_var_id != undefined){      
    //             var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + current_var_id;
    //             window.history.replaceState({path: newurl}, '', newurl);
    //      }
    //     }, 100);
    // });

    // $('.product-variant input').click(function() {
    //     setTimeout(function () {     
    //     var slected_value = $('.product__info-container .actual-variants option:selected').attr('data-variant_id');
    //     var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + slected_value;
    //     window.history.replaceState({path: newurl}, '', newurl);
    //     console.log('var id-' + slected_value);
    //     $('.js-cw-product-page-form.form input[name="klavio_value"]').val(slected_value).trigger('change');
    //     }, 10);
    // });
});